/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ScheduleProducerUpdate = {
  dayOfWeek?: ScheduleProducerUpdate.dayOfWeek;
  /**
   * HH:mm format
   */
  localTime?: string;
  scheduleTypeId?: string;
  zoneId?: string;
};
export namespace ScheduleProducerUpdate {
  export enum dayOfWeek {
    MONDAY = 'MONDAY',
    TUESDAY = 'TUESDAY',
    WEDNESDAY = 'WEDNESDAY',
    THURSDAY = 'THURSDAY',
    FRIDAY = 'FRIDAY',
    SATURDAY = 'SATURDAY',
    SUNDAY = 'SUNDAY',
  }
}

